import { OrderDetailAttributes } from "@albatrosdeveloper/ave-models-package";
import { Injectable } from "@angular/core";
import {
  ExportContext,
  ExportFileFormat,
  ExportRange,
  ExportService,
  ExportTaskProcessor,
} from "app/layout/export-overlay";
import ceil from "lodash-es/ceil";
import get from "lodash-es/get";
import { OrderCustomerService } from "../../order-customer/order-customer.service";
import {
  DELIVERY_REJECTION_EXPORT_ID,
  LOCALIZED_PROPERTIES,
} from "./delivery-rejection.constant";
import { StatusEnum } from '@albatrosdeveloper/ave-models-package/lib/enums';
import { formatLuxonDate } from "../../../../sales/order-list-components/exports/sales-orders-list.utils";

@Injectable()
export class DeliveryRejectionExport {
  constructor(
    private exportService: ExportService,
    private orderCustomer: OrderCustomerService
  ) {}

  private transformItem(item: OrderDetailAttributes) {
    return {
      code: get(item, "subRoute.externalKeys.code", "??"),
      subRoute: get(item, "subRoute.name", "??"),
      user: get(item, "user", "??"),
      trip: get(item, "trip.id", "??"),
      serials: get(item, "serials", "??"),
      date: ExportTaskProcessor.types.excel.date(get(item, "date", null)),
      shipToExternalKey: get(item, "shipToExternalKeyCode", "??"),
      shipToName: get(item, "shipToName", "??"),
      soldToExternalKey:get(item,"soldTo.externalKeys.code","??"),
      soldToName:get(item,"soldTo.name"),
      materialCode: get(item, "materialName.externalKeys.code", "??"),
      materialName: get(item, "materialName.name", "??"),
      baseUnitOfMeasureCode: `${get(item, "baseUnitOfMeasure.code", "??")} ${get(item, "baseUnitOfMeasure.name", "??")}`,
      soldQuantity: get(item, "soldQuantity", "??"),
      pararellUnitOfMeasureCode: `${get(item, "pararellUnitOfMeasure.code", "??")} ${get(item, "pararellUnitOfMeasure.name", "??")}`,
      pararellQuantity: ExportTaskProcessor.types.number(
        get(item, "pararellQuantity", "??")
      ),
      unitPrice: ExportTaskProcessor.types.number(get(item, "unitPrice", "??")),
      subTotal: ExportTaskProcessor.types.number(get(item, "subTotal", "??")),
      total: ExportTaskProcessor.types.number(get(item, "total", "??")),
      status: get(item, "statusId", null) === StatusEnum.INACTIVE ? "ANULADA" : "ACTIVA", // o cualquier otro valor por defecto
      rejectedQuantitiesReasons: get(item, "rejectedQuantitiesReasons", "??"),
      createDateTimeDate: formatLuxonDate(get(item, "detail.createdAt") || get(item, "date"), "dd-MM-yyyy"),
      createDateTimeHour: formatLuxonDate(get(item, "detail.createdAt") || get(item, "date"), "hh:mm:ss a"),
      updateAuditAtDate: formatLuxonDate(get(item, "detail.updatedAt"), "dd-MM-yyyy"),
      updateAuditAtHour: formatLuxonDate(get(item, "detail.updatedAt"), "hh:mm:ss a"),
    };
  }

  export(
    format: ExportFileFormat,
    range: ExportRange,
    totalItems: number,
    pageSize: number,
    pageIndex: number,
    id: string,
    title: string,
    data?: OrderDetailAttributes[]
  ) {
    const totalPages = ceil(totalItems / pageSize) + 1;
    this.exportService
      .task({
        id: id,
        title: title,
        format: format,
        iterations: range === ExportRange.AllPages ? totalPages : 1,
        start: (ctx: ExportContext) => {
          ctx.processor.localizeItemProperties(title, LOCALIZED_PROPERTIES);
        },
        next: (ctx: ExportContext) => {
          data.map((item) => {
            let rejectedQuantitiesReasons = "";
            item.rejectedQuantitiesOnDelivery.forEach((rejected) => {
              rejectedQuantitiesReasons += `${rejected.reasonForRejection.name}, `;
            });
            const newItem = {
              ...item,
              rejectedQuantitiesReasons: rejectedQuantitiesReasons.slice(0, -2), // Remove trailing comma and space
            };
            if (format === ExportFileFormat.Excel) {
              ctx.processor.addToSection(
                title,
                this.transformItem(newItem)
              );
            } else {
              ctx.processor.addToSection(title, this.transformItem(newItem));
            }
          });
          ctx.next();
        },
      })
      .start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(DELIVERY_REJECTION_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}
